//
// Chunk : App
//
// This is only an entry point for webpack chunk.
// There should be no other require than the
// "core" dependencies.
//

// Unsupported Browser Redirect
require("unsupported-browser/redirect.js");

// Event CSS Modifier
require("event-css-modifier/event-css-modifier.js");

// This module is used to disable CSS transition while
// the page is loading. This prevent unwanted CSS transition
// while the DOM is initialize.
require("disable-transition-onload");

// Picture tag polyfill for browser that doesn't support it.
require("picture-polyfill");

// Fonts
require("font/merriweather");
require("font/neutra-text");
require("font/open-sans");

// Catalog
require("catalog/menu");
require("catalog/footer");
require("catalog/home-layout-1/view-1");
require("catalog/fiche-layout-1/view-1");
require("catalog/entete-1/view-1");
require("catalog/entete-2/view-1");
require("catalog/entete-3/view-1");
require("catalog/entete-4/view-1");
require("catalog/porte-1/view-1");
require("catalog/porte-1/view-2");
require("catalog/porte-1/view-3");
require("catalog/banniere-1/view-1");
require("catalog/social-1/view-1");
require("catalog/calendrier-1/view-1");
require("catalog/section-1/view-1");
require("catalog/onglet-1/view-1");
require("catalog/show-layout-1/view-1");
require("catalog/pagination-1/view-1");
require("catalog/filtre-1/view-1");
require("catalog/filtre-2/view-1");
require("catalog/filtre-2/view-2");
require("catalog/thumb-1/view-1");
require("catalog/fiche-info-1/view-1");
require("catalog/fiche-img-1/view-1");
require("catalog/widget-1/view-1");
require("catalog/site-column-1/view-1");
require("catalog/site-page-1/view-1");
require("catalog/fiche-desc-1/view-1");
require("catalog/fiche-sponsor-1/view-1");
require("catalog/promo-2/view-1");
require("catalog/fiche-more-1/view-1");
require("catalog/mosaic-1/view-1");
require("catalog/appel-action-1/view-2");
require("catalog/appel-action-1/view-3");
require("catalog/promo-1/view-1");
require("catalog/citation-1/view-1");
require("catalog/sponsors-1/view-1");
require("catalog/onglet-1/view-2");
require("catalog/titre-1/view-1");
require("catalog/masonry-1/view-1");
require("catalog/card-group-1/view-1");
require("catalog/card-1/view-1");
require("catalog/card-2/view-1");
require("catalog/card-3/view-1");
require("catalog/image-1/view-1");
require("catalog/fiche-onglet-1/view-1");
require("catalog/texte-1/view-1");
require("catalog/fiche-masonry-1/view-1");
require("catalog/fiche-masonry-1/view-2");
require("catalog/intro-1/view-1");
require("catalog/list-desc-1/view-1");
require("catalog/list-link-1/view-1");
require("catalog/list-forfait-1/view-1");
require("catalog/video-1/view-1");
require("catalog/gallery-1/view-1");
require("catalog/download-1/view-1");
require("catalog/separator-1/view-1");
require("catalog/map-1/view-1");
require("catalog/donation-1/view-1");
require("catalog/studio-layout-1/view-1");
require("catalog/warning-text-1/view-1");
require("catalog/formulaire-1/view-1");
require("catalog/info-1/view-1");
require("catalog/reservation-1/view-1");
require("catalog/visionneuse-1/view-1");
require("catalog/promo-3/view-1");
require("catalog/texte-image-1/view-1");
require("catalog/promo-4/view-1");
require("catalog/tag-1/view-1");
require("catalog/home-slider-1/view-1");
require("catalog/notif-1/view-1");
require("catalog/termsfeed-1/view-1");
require("catalog/cookie-notice-1/view-1");

// Style guide
require("style-guide");

// Controllers
require("controllers");

//Date Ranger Picker
require("ctrl-date-range/ctrl-date-range.chunk.js");
require("ctrl-date-range-reservation/ctrl-date-range-reservation.chunk.js");

/* D�sactiver la cache sur les calls AJAX de jQuery.
 * Note: le fait de faire �a dans chunk.app.js signifie que jQuery va toujours faire partie du package, m�me s'il n'est pas utilis� ailleurs.
 * Pas vraiment grave dans le cas pr�sent, puisqu'on sait qu'on utilise jQuery dans d'autres modules.
 */
var jquery = require("jquery");
jquery.ajaxSetup({
  cache: false,
});



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/chunk.app.js
// module id = 0
// module chunks = 0